<template>
  <div class="justify-content-center text-left mt-5 dp02 p-5">
    <div class="col-lg-12">
      <b-button type="submit"
                class="myButton"
                @click="$router.go(-1)"
                style="float:left">
        {{ $t('common.Back') }}
      </b-button>

      <b-button type="submit"
                class="myButton"
                @click="$router.push({ name: 'admin.consultingrooms.edit', params: { id:id } });"
                style="float:right">
        {{ $t('common.Edit') }}
      </b-button>
    </div>
    <div v-if="!ready"
         class="row mt-5">
      <b-spinner variant="primary"
                 type="grow"
                 label="Spinning" />
      <span>{{ $t('DataTable.Loading') }}...</span>
    </div>
    <div v-else
         class="row col-lg-12 mt-5">
      <div class="col-lg-6">
        <h2>{{ $t('entities.ConsultingRoom.Singular') }} {{ name }}</h2>
        <div class="row my-3">
          <div class="col-lg-3">
            <label for="gender">{{ $t('fields.name') }}:</label>
          </div>
          <div class="col-lg-9">
            <b-form-input
              class="myInput"
              :disabled="true"
              v-model="name" />
          </div>
        </div>
        <div class="row my-3">
          <div class="col-lg-3">
            <label for="gender">{{ $t('fields.isEnabled') }}:</label>
          </div>
          <div class="col-lg-9">
            <b-form-checkbox
              :value="true"
              :unchecked-value="false"
              v-model="enabled"
              :disabled="true" />
          </div>
        </div>
        <div class="row my-3">
          <div class="col-lg-3">
            <label for="gender">{{ $t('fields.doctor') }}:</label>
          </div>
          <div class="col-lg-9">
            <DoctorInput v-model="doctor"
                         :editable="false" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import DoctorInput from '@components/input/DoctorInput';

export default {
  name: 'ConsultingRoomViewDetail',
  components: {
    DoctorInput
  },
  data() {
    return {
      ready: false
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
    doctor: {
      get() {
        return this.$store.state.consultingRoomDetail.doctor;
      },
      set() {}
    },
    ...mapState('consultingRoomDetail', ['name', 'enabled']),
  },
  created() {
    this.setConsultingRoomId(this.id);
    this.fetchConsultingRoom()
      .then(() => {
        this.ready = true;
      });
  },
  methods: {
    ...mapActions({ fetchConsultingRoom: 'consultingRoomDetail/fetchConsultingRoom', resetContext: 'consultingRoomDetail/resetContext' }),
    ...mapMutations({ setConsultingRoomId: 'consultingRoomDetail/setConsultingRoomId' })
  }
};
</script>
<style lang="scss" scoped>
</style>
